
var Model = require("../types/Model.js");
var Promise = require("promise");
var xtend = require("xtend");
import par from "par";

module.exports = Model({
	name: "managedforms",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,

	_core_forms: null,
	_current_form: "",
	_who: null,

	reset: reset,
	recalculateSchema: recalculateSchema,
});

function init() {
	this._core_forms = {};
	this._current_form = "";
	this.reset();
}

function uninit() {
	this._core_forms = null;
	this._current_form = "";
}

function triggers() {
	return {
		"start": start,
		"view": view,
		"submit": submit,
		"cancel": cancel,

		"remove:start": start_removing_submission,
		"remove:accept": accept_removing_submission,
		"remove:cancel": cancel_removing_submission,

		"lock:start": start_locking,
		"lock:accept": accept_locking,
		"lock:cancel": cancel_locking,

		"unlock:start": start_unlocking,
		"unlock:accept": accept_unlocking,
		"unlock:cancel": cancel_unlocking,

		"update:start": start_update,
		"update:submit": submit_update,

		"more": load_more,
		"view:section": view_section,
		"reset": trigger_reset,
	};
}

function listeners() {
	return {
		"coreforms:updated": handle_forms_updated,
		"managedformsubmissions:updated": handle_submissions_updated,
		"managedformsubmissions:end": handle_submissions_end
	};
}

function view_section(data) {
	var who = data.who;

	if(who === this._who) {
		this.sayViewing();
		return;
	}

	this.emit("managedfiledata:trigger:view", data);
	this.emit("managedformsubmissions:trigger:view", data);
	this.emit("coreforms:trigger:load");

	this._group = data.group;
	this._who = who;
	this.reset();
	this.extend({
		opened: true
	});

	this.dispatch("viewing");
}

function trigger_reset() {
	this.reset();
	this._who = null;
	this.emit("managedfiledata:trigger:reset");
	this.emit("managedformsubmissions:trigger:reset");
}

function reset() {
	this.push({
		schema: {},
		data: {},
		submissions: [],
		submissionPage: 0,
		submissionEnd: false,
		viewing: null,
		uploading: false,
		updating: false,
		removing: false,
		locking: false,
	});
}

function recalculateSchema() {
	var form = this._current_form;
	var forms = this._core_forms;
	var formData = forms[form];
	if (!formData) return;

	var schema = formData.schema;
	var newSchema = {...schema, properties: {...schema.properties, lock: {format: "checkbox", description: "ae_notes_input_lock"}}};

	this.extend({
		schema: form === "note" ? newSchema : schema
	});
}

function handle_forms_updated(forms) {
	this._core_forms = forms;
	this.recalculateSchema();
}

function handle_submissions_updated(submissions) {
	var update = {
		submissions: submissions
	};
	var currentSubmissionId = this.data.updating;
	if(currentSubmissionId){
		var foundSubmission = submissions.reduce(function(found, current){
			if(found) return found;
			if(current._id === currentSubmissionId)
				return current;
			return null;
		}, null);

		if(foundSubmission) {
			update.updated_at = foundSubmission.updated_at;
			update.data = foundSubmission.data;
			update.isLocked = foundSubmission.isLocked;
		}
	}
	this.extend(update);
}

function start(data) {
	var form = data.form;
	this._current_form = form;

	this.extend({
		data: {}
	});

	this.recalculateSchema();

	this.dispatch("creating", data);

	this.emit("usermetrics:trigger:track", "begin creating managed form submission", {
		who: this._who,
		form,
	});
}

function view(data) {
	var submissionId = data.submission;
	var submission = this.data.submissions.reduce(function (found, current) {
		if (found) return found;
		if (current._id === submissionId) return current;
		return found;
	}, false);

	if (!submission) return;

	var formType = getNameFor(this._core_forms, submission.schema);

	this._current_form = formType;
	this.recalculateSchema();

	this.extend({
		viewing: submissionId,
		data: submission.data
	});

	this.dispatch("opened");

	this.emit("usermetrics:trigger:track", "view submission to managed user's form", {
		who: this._who,
		submission: submissionId,
	});
}

function cancel() {
	this.extend({
		editing: null,
	});
	this.dispatch("cancelled");
	this.emit("usermetrics:trigger:track", "cancel create submission to managed user's submission", {
		who: this._who,
		form: this._current_form,
	});
}

function submit(data) {
	var who = this._who;
	var group = this._group;
	var form = this._current_form;

	this.emit("save:trigger:start");

	var toUpload = data.files;
	var lock = data.lock;
	var newData  = Object.keys(data).filter(key => key !== "lock").reduce((result, key) => {
		result[key] = data[key];
		return result;
	}, {});

	this.emit("usermetrics:trigger:track", "create new submission to managed user's form", {
		who,
		form,
	});

	return Promise.all(toUpload.map(upload_file, this)).then(function(uploaded){
		var formattedFiles = uploaded.map(format_new_file);

		var allData = xtend(newData, {
			files: formattedFiles
		});

		return this.api
			.manage
			.forms
			.submission
			.core(who, form, allData, group, lock);
	}.bind(this))
		.then(handle_success.bind(this))
		.catch(handle_error.bind(this));
}

function handle_success() {
	this.emit("save:trigger:finish");
	this.dispatch("newnote", {
		who: this._who,
		section: "forms",
		timestamp: new Date().toISOString(),
	});
	var message = "note.saved";
	this.emit("toast:trigger:show", {
		content: message
	});
	this.dispatch("closed");
}

function handle_error(e) {
	console.error(e);
	this.emit("save:trigger:finish");
	var message = "note.error";
	this.emit("toast:trigger:show", {
		content: message,
		style: "error"
	});
}

function upload_file(fileData) {
	var file = fileData.file;

	return this
		.api
		.manage
		.file
		.upload(file, this._who, this._group);
}

function delete_file(fileData) {
	var file = fileData.id;
	var who = this._who;
	var group = this._group;

	return this
		.api
		.manage
		.file
		.delete(who, file, group);
}

function start_update(data) {
	var submission = data.submission;

	var submissionData = this.data.submissions.reduce(function (result, item) {
		if (result) return result;
		if (item._id == submission)
			return item;
		return result;
	}, null);

	if (!submissionData) return;

	var formType = getNameFor(this._core_forms, submissionData.schema);

	this._current_form = formType;
	this.recalculateSchema();

	this.extend({
		updating: submission,
		canDelete: submissionData.isCreator,
		data: submissionData.data,
		updated_at: submissionData.updated_at,
		isLocked: submissionData.isLocked,
		locker: submissionData.locker,
	});

	this.dispatch("updating");

	this.emit("usermetrics:trigger:track", "begin updating managed user's form submission", {
		who: this._who,
		submission
	});
}

function submit_update(data) {
	var submission = this.data.updating;
	var who = this._who;
	var group = this._group;

	this.emit("save:trigger:start");

	var existingData = this.data.data;

	var existingFiles = existingData.files || [];
	var newFiles = data.files || [];

	var toDelete = existingFiles.filter(function(existingFile){
		return !newFiles.some(function(newFile){
			return existingFile.id === newFile.id;
		});
	});

	var toUpload = newFiles.filter(function(file){
		return !!file.file;
	});

	var unchanged = newFiles.filter(function(file){
		return !file.file;
	});

	Promise.all([
		Promise.all(toDelete.map(delete_file, this)),
		Promise.all(toUpload.map(upload_file, this))
	]).then(function(results){
		var uploaded = results[1];

		var newFileItems = uploaded.map(format_new_file);

		var allFiles = unchanged.concat(newFileItems);

		var allData = xtend(data, {
			files: allFiles
		});

		return this.api
			.manage
			.forms
			.submission
			.update(who, submission, allData, group);
	}.bind(this))
		.then(handle_update_success.bind(this))
		.catch(handle_error.bind(this));

	this.emit("usermetrics:trigger:track", "update managed user's form submission", {
		who: this._who,
		submission
	});
}

function handle_update_success() {
	this.emit("save:trigger:finish");

	this.extend({
		editing: null,
	});
	this.dispatch("newnote", {
		who: this._who,
		section: "forms",
		timestamp: new Date().toISOString(),
	});
	this.dispatch("updating:closed");
	var message = "note.saved";
	this.emit("toast:trigger:show", {
		content: message
	});
}

function start_locking(data) {
	var submission = data.submission;
	this.extend({
		locking: submission
	});
}

function cancel_locking() {
	this.extend({
		locking: false
	});
}

function accept_locking(data) {
	var submission = data.submission;
	const locker = data.locker;
	var who = this._who;
	var group = this._group;

	this.api
		.manage
		.forms
		.submission
		.lock(who, submission, group)
		.catch(console.error.bind(console))
		.then(par(handle_locked.bind(this), locker));
}

function handle_locked(locker) {
	this.dispatch("locked", {
		submission: this.data.locking
	});
	this.extend({
		locking: false,
		locker: locker 
	});
	var message = "note.locked";
	this.emit("toast:trigger:show", {
		content: message,
	});
}

function start_unlocking(data) {
	var submission = data.submission;
	this.extend({
		unlocking: submission
	});
}

function cancel_unlocking() {
	this.extend({
		unlocking: false
	});
}

function accept_unlocking(data) {
	var submission = data.submission;
	var who = this._who;
	var group = this._group;

	this.api
		.manage
		.forms
		.submission
		.unlock(who, submission, group)
		.catch(console.error.bind(console))
		.then(handle_unlocked.bind(this));
}

function handle_unlocked() {
	this.dispatch("unlocked", {
		submission: this.data.unlocking
	});
	this.extend({
		unlocking: false,
		locker: null,
	});
	var message = "note.unlocked";
	this.emit("toast:trigger:show", {
		content: message,
	});
}

function start_removing_submission(data) {
	var submission = data.submission;
	this.extend({
		removing: submission
	});
	this.emit("usermetrics:trigger:track", "open removing submission from managed user's form popup", {
		who: this._who,
		submission
	});
}

function accept_removing_submission(data) {
	var submission = data.submission;
	var who = this._who;
	var group = this._group;

	this.api
		.manage
		.forms
		.submission
		.remove(who, submission, group)
		.catch(console.error.bind(console))
		.then(handle_removed.bind(this));

	this.emit("usermetrics:trigger:track", "remove submission from managed user's form", {
		who: this._who,
		submission
	});
}

function handle_removed() {
	this.dispatch("removed", {
		submission: this.data.removing
	});
	this.extend({
		removing: false
	});
	var message = "note.deleted";
	this.dispatch("newnote", {
		who: this._who,
		section: "forms",
		timestamp: new Date().toISOString(),
	});
	this.emit("toast:trigger:show", {
		content: message,
		style: "error"
	});
}

function cancel_removing_submission() {
	this.extend({
		removing: false
	});

	this.emit("usermetrics:trigger:track", "close removing submission from managed user's form popup", {
		who: this._who
	});
}

function load_more() {
	var page = this.data.submissionPage + 1;
	this.emit("managedformsubmissions:trigger:load", {
		page: page
	});

	this.extend({
		submissionPage: page
	});

	this.emit("usermetrics:trigger:track", "load more submissions in managed user's form", {
		who: this._who,
		form: this._current_form
	});
}

function format_new_file(file) {
	return {
		url: file.url,
		id: file._id,
		format: file.format
	};
}

function getNameFor(forms, id) {
	return Object.keys(forms).reduce(function (found, name) {
		if (found) return found;
		if (forms[name]._id === id) return name;
		return found;
	}, false);
}

function handle_submissions_end(){
	this.extend({
		submissionEnd: true
	});
}
